import React, { useState } from 'react';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'premium'>('premium');
  const packs = {
    basic: {
      id: 'basic',
      icon: '📘',
      title: 'MEGAPACK DESCANSO PROFUNDO LISTO',
      subtitle: '6 Tomos + 4 Bonos',
      ideal: 'Niños de 1 a 12 años',
      oldPrice: '$44.000',
      price: '$19.990 ARS',
      url: 'https://checkout.zentralpro.store/cart/44190248665124:1',
      ctaText: '→ QUIERO MI MEGAPACK'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      badge: '⭐ MÁS VENDIDO',
      title: 'MEGAPACK + DESCANSO FAMILIAR COMPLETO',
      subtitle: '6 Tomos + 4 Bonos + Adolescentes + Adultos',
      ideal: 'Toda la familia — de 1 año a los padres',
      oldPrice: '$86.000',
      price: '$27.990 ARS',
      url: 'https://checkout.zentralpro.store/cart/44190249746468:1',
      ctaText: '→ QUIERO EL MEGAPACK FAMILIAR COMPLETO'
    }
  };
  const selected = packs[selectedPack];
  return <div id="precios" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
      <div className="bg-night-light rounded-3xl p-6 md:p-10 shadow-xl border border-white/10" data-id="element-260">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-10 text-white" data-id="element-261">
          ELEGÍ TU MEGAPACK
        </h2>

        <div className="space-y-4 mb-10" data-id="element-262">
          {/* Basic Pack Card */}
          <div onClick={() => setSelectedPack('basic')} className={`relative rounded-2xl p-5 md:p-6 cursor-pointer transition-all border-2 flex items-center gap-4 md:gap-6 ${selectedPack === 'basic' ? 'border-gold bg-gold/5' : 'border-white/10 hover:border-white/20 bg-transparent'}`} data-id="element-263">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-gold' : 'border-white/30'}`} data-id="element-264">
              {selectedPack === 'basic' && <div className="w-3 h-3 rounded-full bg-gold" data-id="element-265" />}
            </div>

            <div className="flex-grow flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-266">
              <div className="flex-1" data-id="element-267">
                <div className="text-2xl mb-2" data-id="element-268">{packs.basic.icon}</div>
                <h3 className="text-xl font-bold text-white leading-tight" data-id="element-269">
                  {packs.basic.title}
                </h3>
                <p className="text-base text-gray-300 mt-1" data-id="element-270">
                  {packs.basic.subtitle}
                </p>
                <p className="text-sm text-gold mt-2 font-medium" data-id="element-271">
                  Ideal para: {packs.basic.ideal}
                </p>
              </div>
              <div className="text-left sm:text-right flex-shrink-0 flex flex-col justify-center" data-id="element-272">
                <div className="text-gray-500 line-through text-sm mb-1 font-medium" data-id="element-273">
                  {packs.basic.oldPrice}
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gold" data-id="element-274">
                  {packs.basic.price}
                </div>
              </div>
            </div>
          </div>

          {/* Premium Pack Card */}
          <div onClick={() => setSelectedPack('premium')} className={`relative rounded-2xl p-5 md:p-6 cursor-pointer transition-all border-2 flex items-center gap-4 md:gap-6 ${selectedPack === 'premium' ? 'border-gold bg-gold/5' : 'border-white/10 hover:border-white/20 bg-transparent'}`} data-id="element-275">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 'premium' ? 'border-gold' : 'border-white/30'}`} data-id="element-276">
              {selectedPack === 'premium' && <div className="w-3 h-3 rounded-full bg-gold" data-id="element-277" />}
            </div>

            <div className="flex-grow flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-278">
              <div className="flex-1" data-id="element-279">
                <div className="text-2xl mb-2 flex items-center gap-2" data-id="element-280">
                  {packs.premium.icon}
                  <span className="text-sm font-bold bg-gold/15 text-gold px-3 py-1 rounded-full uppercase tracking-wider border border-gold/30" data-id="element-281">
                    {packs.premium.badge}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white leading-tight" data-id="element-282">
                  {packs.premium.title}
                </h3>
                <p className="text-base text-gray-300 mt-1" data-id="element-283">
                  {packs.premium.subtitle}
                </p>
                <p className="text-sm text-gold mt-2 font-medium" data-id="element-284">
                  Ideal para: {packs.premium.ideal}
                </p>
              </div>
              <div className="text-left sm:text-right flex-shrink-0 flex flex-col justify-center" data-id="element-285">
                <div className="text-gray-500 line-through text-sm mb-1 font-medium" data-id="element-286">
                  {packs.premium.oldPrice}
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gold" data-id="element-287">
                  {packs.premium.price}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mb-6" data-id="element-288">
          <div className="bg-night-lighter text-white text-sm font-medium px-6 py-2 rounded-full inline-flex items-center gap-2 shadow-inner" data-id="element-289">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-290"></span>
            Oferta válida por tiempo limitado
          </div>
        </div>

        <a href={selected.url} target="_blank" rel="noopener noreferrer" className="block w-full bg-terracotta hover:bg-terracotta-light text-white text-center font-bold py-5 px-6 rounded shadow-md hover:shadow-lg transition-all text-xl" data-id="element-291">
          {selected.ctaText}
        </a>
      </div>
    </div>;
}